import React from 'react';
import WhatsAppCloneApp from '../whatsapp-embed/WhatsAppCloneApp';

// Public WhatsApp-mobile clone: opens straight into a conversation, no
// contact list, no device-frame mockup — just the chat screen itself,
// filling whatever viewport it's opened in (phone, tablet, desktop window).
function WhatsAppMobilePage() {
	return (
		<div style={{ position: 'fixed', inset: 0, width: '100vw', height: '100dvh' }}>
			<WhatsAppCloneApp chatOnly />
		</div>
	);
}

export default WhatsAppMobilePage;
